/* eslint-disable no-undef */
/*Framework Imports */
import React, { useState, useEffect } from "react";

/*Css Imports*/
import "./validate.css";

/*Third Party Imports*/
import Form, {
  GroupItem,
  SimpleItem,
  ButtonItem,
  RequiredRule,
  EmailRule,
  PatternRule,
  Label,
} from "devextreme-react/form";
import Box, { Item } from "devextreme-react/box";
import Button from "devextreme-react/button";
import { Alert } from "reactstrap";
import { useParams } from "react-router-dom";

/*Api Imports */
import validateApi from "../../infrastructure/validateapi";
import authenticationApi from "../../infrastructure/authenticationapi";

/*Utilities import */
import utilities from "../../infrastructure/utilities";

/*Component Imports */
import Timer from "./timer";

/*Local Instances*/
const dynamicId = utilities.generateUUID();

/*Component Declaration*/
const Validate = (props) => {
  //Get member id
  const useParamsObject = useParams();
  const memberId = useParamsObject.memberId;

  //Local State
  /*Local state*/
  const [isLoading, setIsLoading] = useState(true);
  const [formData, setFormdata] = useState({
    ["email" + dynamicId]: useParamsObject.existingEmail,
    ["phone" + dynamicId]: useParamsObject.existingPhone,
    ["emailCode" + dynamicId]: "",
    ["phoneCode" + dynamicId]: "",
    emailConfirmed: false,
    phoneConfirmed: false,
  });
  const [existingEmail, setExistingEmail] = useState(
    useParamsObject.existingEmail
  );
  const [existingPhone, setExistingPhone] = useState(
    useParamsObject.existingPhone
  );
  const [errorMessageEmail, setErrorMessageEmail] = useState("");
  const [errorMessagePhone, setErrorMessagePhone] = useState("");
  const [validationDate, setValidationDate] = useState();
  const [expiredForm, setExpiredForm] = useState(true);

  /*Initial Load Hook*/
  useEffect(() => {
    //Add Validation Date
    let storedValidationDate;
    storedValidationDate = localStorage.getItem("onboarddate" + memberId);
    if (
      !(storedValidationDate !== undefined && storedValidationDate !== null)
    ) {
      storedValidationDate = new Date();
      localStorage.setItem("onboarddate" + memberId, storedValidationDate);
    }
    setValidationDate((prevState) => storedValidationDate);

    //Validate if has already been email confirmed
    if (localStorage.getItem("onboardemailconfirmed" + memberId) === "true") {
      //Set email confirmed
      setFormdata((prevState) => {
        return { ...prevState, emailConfirmed: true };
      });
    }
    //Validate if has already been email validated
    if (localStorage.getItem("onboardphoneconfirmed" + memberId) === "true") {
      //Set email confirmed
      setFormdata((prevState) => {
        return { ...prevState, phoneConfirmed: true };
      });
    }

    setIsLoading((prevState) => false);
    authenticationApi.auth();
  }, [memberId]);

  /*Event Handlers */
  const onformvalidateemailDataChange = (e) => {
    const res = e.component.validate();
    e.component.getButton("editEmail").option("disabled", !res.isValid);
  };

  const onformvalidateemailcodeDataChange = (e) => {
    const res = e.component.validate();
    if (res.isValid) onValidateCodeEmail();
  };

  const onformvalidatephoneDataChange = (e) => {
    const res = e.component.validate();
    e.component.getButton("editPhone").option("disabled", !res.isValid);
  };

  const onformvalidatephonecodeDataChange = (e) => {
    const res = e.component.validate();
    if (res.isValid) onValidateCodePhone();
  };

  const onEditEmailButtonClick = (e) => {
    //Start loader
    setIsLoading((prevState) => true);
    //Prevent default submit
    e.event.preventDefault();
    //Create payload object
    const payLoad = {};
    payLoad.email = formData["email" + dynamicId];
    //call the api
    validateApi.editEmail(memberId, payLoad, setIsLoading).then((res) => {
      if (res !== undefined) {
        setIsLoading((prevState) => false);
        setExistingEmail((prevState) => formData["email" + dynamicId]);

        //Display Friendly message and save the error to console
        setErrorMessageEmail(
          (prevState) =>
            "s:The code was sent to your email. Please check your inbox!"
        );
      } else {
        setErrorMessageEmail(
          (prevState) => "e:Something went wrong, please try again later!"
        );
      }
    });
  };

  const onEditPhoneButtonClick = (e) => {
    //Start loader
    setIsLoading((prevState) => true);
    //Prevent default submit
    e.event.preventDefault();
    //Create payload object
    const payLoad = {};
    payLoad.phone = formData["phone" + dynamicId];
    //call the api
    validateApi.editPhone(memberId, payLoad, setIsLoading).then((res) => {
      if (res !== undefined) {
        setExistingPhone((prevState) => formData["phone" + dynamicId]);
        setIsLoading((prevState) => false);
        //Display Friendly message and save the error to console
        setErrorMessagePhone(
          (prevState) =>
            "s:The code was sent to your phone. Please check your phone!"
        );
      } else {
        setErrorMessagePhone(
          (prevState) => "e:Something went wrong, please try again later!"
        );
      }
    });
  };

  const onResendEmailButtonClick = (e) => {
    //Start loader
    setIsLoading((prevState) => true);
    //Prevent default submit
    e.event.preventDefault();
    const payLoad = {};
    payLoad.email = existingEmail;
    //call the api
    validateApi.resendEmail(memberId, payLoad, setIsLoading).then((res) => {
      if (res !== undefined) {
        setIsLoading((prevState) => false);
        //Display Friendly message and save the error to console
        setErrorMessageEmail(
          (prevState) =>
            "s:The code was sent to your email. Please check your inbox!!"
        );
      } else {
        setErrorMessageEmail(
          (prevState) => "e:Something went wrong, please try again later!"
        );
      }
    });
  };

  const onResendPhoneButtonClick = (e) => {
    //Start loader
    setIsLoading((prevState) => true);
    //Prevent default submit
    e.event.preventDefault();
    //payload
    const payLoad = {};
    payLoad.phone = existingPhone;
    //call the api
    validateApi.resendPhone(memberId, payLoad, setIsLoading).then((res) => {
      if (res !== undefined) {
        setIsLoading((prevState) => false);
        //Display Friendly message and save the error to console
        setErrorMessagePhone(
          (prevState) =>
            "s:The code was sent to your phone. Please check your phone!"
        );
      } else {
        setErrorMessagePhone(
          (prevState) => "e:Something went wrong, please try again later!"
        );
      }
    });
  };

  const onValidateCodeEmail = () => {
    //Start loader
    setIsLoading((prevState) => true);
    //Create payload object
    const payLoad = {};
    payLoad.code = formData["emailCode" + dynamicId];
    payLoad.email = existingEmail;
    //call the api
    validateApi
      .validateCodeEmail(memberId, payLoad, setIsLoading)
      .then((res) => {
        if (res !== undefined) {
          setIsLoading((prevState) => false);
          setErrorMessageEmail((prevState) => "");
          //Set email confirmed
          setFormdata((prevState) => {
            return { ...prevState, emailConfirmed: true };
          });
          //Set local storage variable
          localStorage.setItem("onboardemailconfirmed" + memberId, true);
        } else {
          setErrorMessageEmail(
            (prevState) => "e:Code is Invalid, please try again!"
          );
        }
      });
  };

  const onValidateCodePhone = () => {
    //Start loader
    setIsLoading((prevState) => true);
    //Create payload object
    const payLoad = {};
    payLoad.code = formData["phoneCode" + dynamicId];
    payLoad.phone = existingPhone;
    //call the api
    validateApi
      .validateCodePhone(memberId, payLoad, setIsLoading)
      .then((res) => {
        if (res !== undefined) {
          setIsLoading((prevState) => false);
          setErrorMessagePhone((prevState) => "");
          //Set email confirmed
          setFormdata((prevState) => {
            return { ...prevState, phoneConfirmed: true };
          });
          //Set local storage variable
          localStorage.setItem("onboardphoneconfirmed" + memberId, true);
        } else {
          setErrorMessagePhone(
            (prevState) => "e:Code is Invalid, please try again!"
          );
        }
      });
  };

  return (
    <div>
      {isLoading && <div className="loading">Loading</div>}
      <Box direction="row" width="100%">
        <Item ratio={0.05}></Item>
        <Item ratio={2}>
          <Box direction="row" width="100%">
            <Item ratio={2}>
              <Alert fade={false} color="primary" className="alert-margin">
                <h5 className="alert-heading">
                  <b>Thank you for Registering!</b>
                </h5>
                <p>
                  We will now validate your email and cell phone number
                  <br />
                  <br />
                  <span className="remainingtime">&nbsp;</span>
                </p>
              </Alert>
            </Item>
            <Item ratio={2}>
              <Alert fade={false} color="warning">
                <h5 className="alert-heading">
                  <b>
                    This form will be available for{" "}
                    {config.expirationTimeMinutes} minutes
                  </b>
                </h5>
                <p>
                  After that time you will have to start the registration
                  process again
                  <br />
                  <br />
                  <span className="remainingtime">
                    <b>
                      Remaining Time:{" "}
                      <Timer
                        validationDate={validationDate}
                        setExpiredForm={setExpiredForm}
                      />
                    </b>
                  </span>
                </p>
              </Alert>
            </Item>
          </Box>
          {!expiredForm && (
            <div id="phoneValidation">
              <Form
                id="formvalidatephone"
                formData={formData}
                colCount={1}
                onFieldDataChanged={onformvalidatephonecodeDataChange}
                elementAttr={{ "aria-label": "Cell Phone Validation" }}
                labelLocation="top"
                labelMode="outside"
              >
                <GroupItem
                  caption={"Cell Phone Validation"}
                  colSpan={1}
                  colCount={6}
                >
                  {formData.phoneConfirmed === true && (
                    <SimpleItem colSpan={6}>
                      <Alert fade={false} color="success">
                        <h4 className="alert-heading">
                          Your cell phone has been validated succesfully!
                        </h4>
                      </Alert>
                    </SimpleItem>
                  )}
                  {errorMessagePhone !== "" && (
                    <SimpleItem colSpan={6}>
                      <Alert
                        fade={false}
                        id="alertphone"
                        color={
                          errorMessagePhone.startsWith("e:")
                            ? "danger"
                            : "success"
                        }
                      >
                        <h4 className="alert-heading">
                          {errorMessagePhone.substring(2)}
                        </h4>
                      </Alert>
                    </SimpleItem>
                  )}
                  {formData.phoneConfirmed === false && (
                    <SimpleItem colSpan={6}>
                      Please enter the 6 digits number from the text message
                      into the validation block below
                    </SimpleItem>
                  )}
                  {formData.phoneConfirmed === false && (
                    <SimpleItem
                      colSpan={6}
                      editorType={"dxTextBox"}
                      dataField={"phoneCode" + dynamicId}
                      editorOptions={{
                        inputAttr: {
                          autocomplete: "randomvalue",
                          style: "font-size:16px",
                        },
                        maxLength: 6,
                        useMaskValue: true,
                        mask: "0 0 0 0 0 0",
                        maskInvalidMessage: "Code should be 6 digits",
                        valueChangeEvent: "change keyup",
                        maskChar: "_ ",
                        width: "115",
                        onFocusIn: (e) => {
                          if (e.component.option("value") === "") {
                            e.component
                              .element()
                              .children[1].children[0].children[0].setSelectionRange(
                                0,
                                0
                              );
                          }
                        },
                        mode: "tel",
                      }}
                    >
                      <RequiredRule message="Code is required" />
                      <Label text={"Enter the 6 digit phone validation code"} />
                    </SimpleItem>
                  )}
                  {formData.phoneConfirmed === false && (
                    <ButtonItem
                      name="resendPhoneCode"
                      horizontalAlignment="left"
                      buttonOptions={{
                        text: "Resend Code",
                        type: "success",
                        useSubmitBehavior: false,
                        disabled: false,
                        onClick: onResendPhoneButtonClick,
                        width: "250",
                      }}
                    />
                  )}
                </GroupItem>
              </Form>
              {formData.phoneConfirmed === false && (
                <Form
                  id="formvalidatephonecode"
                  formData={formData}
                  colCount={6}
                  onFieldDataChanged={onformvalidatephoneDataChange}
                  elementAttr={{ "aria-label": "Resend Code to Phone" }}
                  labelLocation="top"
                  labelMode="outside"
                >
                  {formData.phoneConfirmed === false && (
                    <SimpleItem colSpan={6}>
                      If you need to modify your phone you cand do it on the box
                      below
                    </SimpleItem>
                  )}
                  {formData.phoneConfirmed === false && (
                    <SimpleItem
                      colSpan={6}
                      dataField={"phone" + dynamicId}
                      label={{ text: "Cell Phone" }}
                      editorOptions={{
                        inputAttr: {
                          autocomplete: "randomvalue",
                          style: "font-size:16px",
                        },
                        mask: "(000) 000-0000",
                        maskInvalidMessage:
                          "The cell phone must have a correct phone format",
                        valueChangeEvent: "change keyup",
                        width: "250",
                        defaultValue: existingPhone,
                        mode: "tel",
                      }}
                    >
                      <PatternRule
                        message="The phone must have a correct phone format"
                        pattern={/^[0-9]\d{9}$/}
                      />
                      <RequiredRule message="Cell Phone is Required" />
                    </SimpleItem>
                  )}
                  {formData.phoneConfirmed === false && (
                    <ButtonItem
                      name="editPhone"
                      horizontalAlignment="left"
                      colSpan={6}
                      buttonOptions={{
                        text: "Edit Phone and Resend Code",
                        type: "success",
                        useSubmitBehavior: true,
                        disabled: false,
                        onClick: onEditPhoneButtonClick,
                        width: "250",
                      }}
                    />
                  )}
                </Form>
              )}
            </div>
          )}
          {!expiredForm && (
            <div id="emailValidation">
              <Form
                id="formvalidateemail"
                formData={formData}
                colCount={1}
                onFieldDataChanged={onformvalidateemailcodeDataChange}
                elementAttr={{ "aria-label": "Email Validation" }}
                labelLocation="top"
                labelMode="outside"
              >
                <GroupItem
                  caption={"Email Validation"}
                  colSpan={1}
                  colCount={6}
                  colCountByScreen={6}
                >
                  {formData.emailConfirmed === true && (
                    <SimpleItem colSpan={6}>
                      <Alert fade={false} color="success">
                        <h4 className="alert-heading">
                          Your email has been validated succesfully!
                        </h4>
                      </Alert>
                    </SimpleItem>
                  )}
                  {errorMessageEmail !== "" && (
                    <SimpleItem colSpan={6}>
                      <Alert
                        fade={false}
                        id="alertemail"
                        color={
                          errorMessageEmail.startsWith("e:")
                            ? "danger"
                            : "success"
                        }
                      >
                        <h4 className="alert-heading">
                          {errorMessageEmail.substring(2)}
                        </h4>
                      </Alert>
                    </SimpleItem>
                  )}
                  {formData.emailConfirmed === false && (
                    <SimpleItem colSpan={6}>
                      Please enter the 6 digits number from the email into the
                      validation block below
                    </SimpleItem>
                  )}
                  {formData.emailConfirmed === false && (
                    <SimpleItem
                      colSpan={6}
                      editorType={"dxTextBox"}
                      dataField={"emailCode" + dynamicId}
                      editorOptions={{
                        id: "emailCode" + dynamicId,
                        inputAttr: {
                          autocomplete: "randomvalue",
                          style: "font-size:16px",
                        },
                        maxLength: 6,
                        useMaskValue: true,
                        mask: "0 0 0 0 0 0",
                        maskInvalidMessage: "Code should be 6 digits",
                        valueChangeEvent: "change keyup",
                        maskChar: "_ ",
                        width: "115",
                        onFocusIn: (e) => {
                          if (e.component.option("value") === "") {
                            e.component
                              .element()
                              .children[1].children[0].children[0].setSelectionRange(
                                0,
                                0
                              );
                          }
                        },
                        mode: "tel",
                      }}
                    >
                      <RequiredRule message="Code is required" />
                      <Label text={"Enter the 6 digit email validation code"} />
                    </SimpleItem>
                  )}
                  {formData.emailConfirmed === false && (
                    <ButtonItem
                      name="resendEmailCode"
                      horizontalAlignment="left"
                      elementAttr={{ style: { "max-width": "350" } }}
                      buttonOptions={{
                        text: "Resend Code",
                        type: "success",
                        useSubmitBehavior: false,
                        disabled: false,
                        onClick: onResendEmailButtonClick,
                        width: "250",
                      }}
                    />
                  )}
                </GroupItem>
              </Form>
              {formData.emailConfirmed === false && (
                <Form
                  id="formvalidateemailcode"
                  formData={formData}
                  colCount={6}
                  onFieldDataChanged={onformvalidateemailDataChange}
                  elementAttr={{ "aria-label": "Email Resend Code" }}
                  labelLocation="top"
                  labelMode="outside"
                >
                  {formData.emailConfirmed === false && (
                    <SimpleItem colSpan={6}>
                      If you need to modify your email you cand do it on the box
                      below
                    </SimpleItem>
                  )}
                  {formData.emailConfirmed === false && (
                    <SimpleItem
                      colSpan={6}
                      editorType={"dxTextBox"}
                      dataField={"email" + dynamicId}
                      label={{ text: "Email" }}
                      editorOptions={{
                        inputAttr: {
                          autocomplete: "randomvalue",
                          style: "font-size:16px",
                        },
                        valueChangeEvent: "change keyup",
                        width: "250",
                        defaultValue: existingEmail,
                        mode: "email",
                      }}
                    >
                      <EmailRule message="Email is invalid" />
                      <RequiredRule message="Email is required" />
                    </SimpleItem>
                  )}
                  {formData.emailConfirmed === false && (
                    <ButtonItem
                      name="editEmail"
                      horizontalAlignment="left"
                      colSpan={6}
                      buttonOptions={{
                        text: "Edit Email and Resend Code",
                        type: "success",
                        useSubmitBehavior: true,
                        disabled: false,
                        onClick: onEditEmailButtonClick,
                        width: "250",
                      }}
                    />
                  )}
                </Form>
              )}
            </div>
          )}

          {formData.phoneConfirmed === true &&
            formData.emailConfirmed === true && (
              <Alert fade={false} color="primary">
                <h5 className="alert-heading">
                  Thank you for verifying your Email and Cell phone number!
                </h5>
                <p>
                  You will now receive another email telling you how to download
                  our "Onboarding app" from your Android or iOS app store and
                  how to login so you can develop your profile with us.
                </p>

                <p>We look forward to working with you soon!</p>
              </Alert>
            )}
          {formData.phoneConfirmed === true &&
            formData.emailConfirmed === true && (
              <Button
                text="Continue to the NSA web site"
                type="success"
                useSubmitBehavior={false}
                onClick={(e) =>
                  (window.location.href = "https://nsafieldservice.com/")
                }
              />
            )}
        </Item>
        <Item ratio={0.05}></Item>
      </Box>
    </div>
  );
};

/*Component Export*/
export default Validate;
